import Content from "./Content"
import Page from "./404"
import { format } from 'date-fns';
import "./App.css";
import 'react-lazy-load-image-component/src/effects/blur.css';
import React, { useEffect, useState } from "react";
const App = () => {
  const now = new Date();

  // Format date and time using date-fns


  const [ready, setReady] = useState(false)
  useEffect(() => {
    const formattedDate = format(now, 'yyyy/MM/dd');
    const formattedTime = format(now, 'HH:mm:ss');



    if (formattedDate >= '2024/12/10') {
      setReady(true)
    }



  }, [])

  return (
    ready === true ? <Content /> : <Page />

  );
};


export default App;
